
import type { RouteObject } from 'react-router-dom';
import Home from '../pages/home/page';
import Services from '../pages/services/page';
import Portfolio from '../pages/portfolio/page';
import NotFound from '../pages/NotFound';
import { Navigate } from 'react-router-dom';
import BlogPage from '../pages/blog/page';
import DashboardPage from '../pages/dashboard/page';
import WebsiteDevelopment from '../pages/services/website-development/page';
import EcommerceSolutions from '../pages/services/ecommerce/page';
import Testimonials from '../pages/testimonials/page';
import Contact from '../pages/contact/page';
import Pricing from '../pages/pricing/page';
import VibeCheckPage from '../pages/vibe-check/page';
import MockupPreviewPage from '../pages/mockup-preview/page';
import PrivacyPolicyPage from '../pages/privacy-policy/page';
import TermsOfServicePage from '../pages/terms-of-service/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />
  },
  {
    path: '/services',
    element: <Services />
  },
  {
    path: '/services/website-development',
    element: <WebsiteDevelopment />
  },
  {
    path: '/services/ecommerce',
    element: <EcommerceSolutions />
  },
  {
    path: '/portfolio',
    element: <Portfolio />
  },
  {
    path: '/pricing',
    element: <Pricing />
  },
  {
    path: '/testimonials',
    element: <Testimonials />
  },
  {
    path: '/contact',
    element: <Contact />
  },
  {
    path: '/intake',
    element: <Navigate to="/vibe-check" replace />
  },
  {
    path: '/blog/:slug',
    element: <BlogPage />
  },
  {
    path: '/blog',
    element: <BlogPage />
  },
  {
    path: '/dashboard',
    element: <DashboardPage />
  },
  {
    path: '/dashboard/register',
    element: <DashboardPage />
  },
  {
    path: '/dashboard/forgot-password',
    element: <DashboardPage />
  },
  {
    path: '/vibe-check',
    element: <VibeCheckPage />
  },
  {
    path: '/mockup-preview',
    element: <MockupPreviewPage />
  },
  {
    path: '/mockup-compare',
    element: <Navigate to="/mockup-preview" replace />
  },
  {
    path: '/terms-of-service',
    element: <TermsOfServicePage />
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicyPage />
  },  {
    path: '*',
    element: <NotFound />
  },
];

export default routes;
